export default __webpack_public_path__ + "static/newsletter-b829c869e9aeb105b02b9ff9f2be7ce6.png";